import { render, staticRenderFns } from "./MerchantBenefits.vue?vue&type=template&id=7ef2ed42&scoped=true&"
import script from "./MerchantBenefits.vue?vue&type=script&lang=js&"
export * from "./MerchantBenefits.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBenefits.vue?vue&type=style&index=0&id=7ef2ed42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef2ed42",
  null
  
)

export default component.exports